export enum UploadLocation {
  RISKDESCRIPTION = 'riskdescription',
  RISKLOCATION = 'risklocation',
  PREVIOUSDAMAGE = 'previousdamage',
  PROPOSALINFORMATION = 'proposalinformation',
  INDIVIDUALCLAUSESCONDITIONS = 'individualclausesconditions',
  BILLBOARDGENERAL = 'billboardgeneral',
  BILLBOARDGENERALMEETINGS = 'billboardgeneralmeetings',
  BILLBOARDAUTHORISATIONS = 'billboardauthorisations',
  BILLBOARDAPPLICATIONS = 'billboardapplications',
}
